// =============================================================================
// src/features/crisis/crisis-live-store.ts
//
// Override vivo (Sentinel/AtalaIA) da tela de Crise: série horária real, gauge,
// slivers, amplificadores e origem do tópico de maior gauge. Sem patch, a tela
// mantém o mock. SRP: só estado de override + getters. Sem DOM, sem fetch.
// =============================================================================

import { EVO_SERIES as STATIC_EVO } from './crisis-chart-geometry';
import type { CrisisAmplifier, CrisisLiveAction, CrisisLivePatch } from '../../data/sentinel-overlay';

let liveSeries: number[] | null = null;
let liveActions: CrisisLiveAction[] | null = null;
let liveMetrics: CrisisLivePatch | null = null;

export function getEvoSeries(): readonly number[] {
  return liveSeries?.length ? liveSeries : STATIC_EVO;
}

export function applyCrisisLiveSeries(series: readonly number[]): void {
  if (!series.length) return;
  liveSeries = series.slice(-24);
}

export function getCrisisLiveActions(): readonly CrisisLiveAction[] {
  return liveActions ?? [];
}

export function applyCrisisLiveActions(actions: readonly CrisisLiveAction[]): void {
  liveActions = actions.length ? actions.map((action) => ({ ...action, tags: [...action.tags] })) : null;
}

/** Métricas/amplificadores/origem da crise ativa (ou null = mock). A série vai p/ getEvoSeries. */
export function applyCrisisLivePatch(patch: CrisisLivePatch): void {
  if (Object.keys(patch).length === 0) return;
  if (patch.series?.length) applyCrisisLiveSeries(patch.series);
  liveMetrics = patch;
}

/** Patch vivo da crise (gauge, slivers, origem, fase) ou null. */
export function getCrisisMetrics(): CrisisLivePatch | null {
  return liveMetrics;
}

/** Amplificadores do tópico ativo (vazio sem crise viva). */
export function getCrisisAmplifiers(): readonly CrisisAmplifier[] {
  return liveMetrics?.amplifiers ?? [];
}

export function __resetCrisisLiveForTests(): void {
  liveSeries = null;
  liveActions = null;
  liveMetrics = null;
}
